import React, { useCallback, useEffect, useRef, useState } from "react";
import { Spin, Select, DatePicker, Checkbox, Form, Input, Button, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getOmsStockSummary } from "../../redux/actions/omsStockSummary.action";
import { getGenderCategory, getGenderCategoryChange } from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getFitCategory, getFitCategoryNew } from "../../redux/actions/fitCategory.action";
import { getProductType } from "../../redux/actions/productType.action";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import { getSize } from "../../redux/actions/size.action";
import { getSku } from "../../redux/actions/sku.action"
import { ReadCookie } from "../../utils/readCookie";
import { getWashName } from "../../redux/actions/wash.action";
import { getStyle, getStyleChange } from "../../redux/actions/style";
import { FilterFilled, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo-black.svg";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import "../Distributor/Distributor.css";
import { Link, useHistory } from "react-router-dom";
import { Excel } from "antd-table-saveas-excel";
import Loader from "react-loader-spinner";
import numeral from "numeral";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getSeasonYear } from "../../redux/actions/seasonYear.action";
import axios from 'axios';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { generateDynamicPDF } from "../../utils/generateDynamicPDF";
import { toDateNew } from "../../utils/ToDate";
const dateFormatList = ["MM-DD-YYYY"];

const OmsStockSummary = ({ token }) => {
  TabTitle("Stock Summary")
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    getWiseStockReport,
    productType,
    gender,
    genderCategory,
    season,
    productStatus,
    productClass,
    size,
    wash,
    fitCategory,
    omsStockSummary,
    genderCategoryChange,
    styleChange,
    Sku,
    seasonYear,
    fitCategoryNew
  } = useSelector((state) => state);
  const history = useHistory();
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const tableRef = useRef(null);
  const [productClassID, setProductClassID] = useState([]);
  const [seasonID, setSeasonID] = useState([]);
  const [isChecked, setIsChecked] = useState([]);
  const [isChecked2, setIsChecked2] = useState([3]);
  const [allSesion, setAllSesion] = useState(true);
  const [allStatus, setAllStatus] = useState(false);
  const [isPCChecked, setIsPCChecked] = useState([]);
  const [allPC, setAllPC] = useState(true);
  const [loading, setLoading] = useState(false);
  const [BgradeCheck, setBgradeCheck] = useState(false);
  const [check, setCheck] = useState(false);
  const [data, setData] = useState([])
  const [excelData, setExcelData] = useState([])
  const [routineLog, setRoutineLog] = useState([]);
  const location = useLocation();
  const [sortClicked, setSortClicked] = useState(false);


  const [genderName, setGenderName] = useState(null);
  const [seasonName, setSeasonName] = useState(null);
  const [yearName, setYearName] = useState(null);
  const [CatergoryName, setCatergoryName] = useState(null);
  const [sku, setSKU] = useState(null);
  const [styleName, setStyleName] = useState(null);
  const [washName, setWashName] = useState(null);
  const [fitName, setFitName] = useState(null);
  const [sortedInfo, setSortedInfo] = React.useState({});
  // console.log("Location", location?.state);
  const initialDate = moment('2026-12-31')

  const { search } = useLocation();

  const query = new URLSearchParams(search);

  let result =
    getWiseStockReport &&
    getWiseStockReport?.payload?.data?.reduce(function (r, a) {
      r[a.item_code] = r[a.item_code] || [];
      r[a.item_code].push(a);
      return r;
    }, Object.create(null));

  const wiseStockReport = result && Object.values(result);

  const values = {
    item_id: null,
    location_id: null,
  };

  const { Option } = Select;
  let pendingDate = "";

  const onChangeDate = (date, dateString) => {
    pendingDate = dateString;
  };

  const sesionSelectAll = (e) => {
    setAllSesion(e.target.checked);
  };
  const statusSelectAll = (e) => {
    setAllStatus(e.target.checked);
    if (e.target.checked) {
      setIsChecked2([]);
    }

  };

  const isCheckboxChecked = (id, value) => {
    const filterCheckBox =
      season && season?.payload?.data.find((val) => val.season_id === id);
    const checkId = isChecked.includes(id);
    if (!checkId) {
      setIsChecked((current) => [...current, filterCheckBox.season_id]);
    }
    if (!value) {
      const removeUnCheck = isChecked.filter(
        (item) => item !== filterCheckBox.season_id
      );
      setIsChecked(removeUnCheck);
    }
    setAllSesion(false);
  };


  const isCheckboxChecked2 = (id, value) => {
    const filterCheckBox =
      productStatus && productStatus?.payload?.data.find((val) => val.product_status_id === id);
    const checkId = isChecked2.includes(id);
    if (!checkId) {
      setIsChecked2((current) => [...current, filterCheckBox.product_status_id]);
    }
    if (!value) {
      const removeUnCheck = isChecked2.filter(
        (item) => item !== filterCheckBox.product_status_id
      );
      setIsChecked2(removeUnCheck);
    }
    setAllStatus(false);
  };

  useEffect(() => {
    if (location?.state && location?.state?.values?.new_season_id) {
      const values = {
        as_on_date: initialDate,
        sku: "",
        season_id: location?.state?.values?.new_season_id,
        gender_id: location?.state?.values?.gender_id,
        gender_category_id: null,
        fit_category_id: null,
        cut_id: null,
        style_id: null,
        product_status_id: null,
        product_class_id: null,
        sort_on: null,
        include_bgrade: "abc",
        wash_id: null,
        new_season_year_id: null
      }
      form.setFieldsValue({
        season_id: values.season_id,
        gender_id: values.gender_id,
      });
      setLoading(true)
      dispatch(getOmsStockSummary(token, values, isChecked, isChecked2, isPCChecked, BgradeCheck)).then((res => {
        setLoading(false)
        setData(res?.payload?.data)
        downloadExcelFileData(res?.payload?.data);
      }));
    }
  }, [location?.state && location?.state?.values?.new_season_id])


  useEffect(() => {
    const qp_status = query.get("current_status_id");
    const qp_gender = query.get("gender_id");
    const qp_style = query.get("style_id");
    const qp_cut = query.get("fit_id");
    // const qp_prod = query.get("fit_category_id");
    const qp_date = query.get("as_on_date");
    // 1. Set checkboxes from status array
    // console.log(qp_status, 'qp_status');

    if (productStatus?.payload?.data && qp_gender && !loading) {
      const newChecked =
        qp_status?.length > 0
          ? qp_status?.split(",").map((v) => Number(v?.trim()))
          : [];
      // console.log(newChecked, 'newChecked');

      setIsChecked2(
        qp_status?.length > 0
          ? qp_status?.split(",").map((v) => Number(v?.trim()))
          : []
      );

      // qp_status
      //   .split(",")
      //   .map(Number)
      //   .forEach(id => isCheckboxChecked2(id, true));

      // 2. Set all form fields from query
      form.setFieldsValue({
        gender_id: qp_gender && qp_gender !== "All" ? Number(qp_gender) : null,
        style_id: qp_style && qp_style !== "All" ? Number(qp_style) : null,
        cut_id: qp_cut && qp_cut !== "All" ? Number(qp_cut) : null,
        // fit_category_id: qp_prod && qp_prod !== "All" ? Number(qp_prod) : null,
        as_on_date: qp_date ? moment(qp_date, "MM-DD-YYYY") : moment(),
      });

      // 3. Jab sab filters set ho jaayein → API call karo
      // console.log(newChecked.every((v, i) => v === isChecked2[i]), 'newChecked.every((v,i) => v === isChecked2[i])');

      if (
        isChecked2?.length === newChecked?.length &&
        isChecked2?.every((v, i) => v === newChecked[i])
      ) {
        // console.log(isChecked2, 'isChecked2isChecked2');

        onFinish();
      }
    }
  }, [query.get("current_status_id"), productStatus?.payload?.data]);


  const onFinish = async (e) => {
    setLoading(true)
    await form.validateFields().then((values) => {
      console.log(values, 'values-----');
      dispatch(
        getOmsStockSummary(token, values, isChecked, isChecked2, isPCChecked, BgradeCheck)).then((res => {
          setLoading(false)
          setData(res?.payload?.data)
          downloadExcelFileData(res?.payload?.data);
        }));
    });
  };

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Gender": v.gender,
          "Current Season": v.current_season,
          "Sku": v.item_code,
          "Inseam": v.inseam,
          "Style": v.style,
          "Wash": v.wash,
          "Fit Category": v.fit_category,
          "WS": `$ ${Number(v.ws_price).toFixed(0)}`,
          "RTL": `$ ${Number(v.retail_price).toFixed(0)}`,
          "BERGEN": v.bergan,
          "TRNS": v.transit,
          "PK": v.pakistan,
          "PROD": v.production,
          "PEND": v.pending,
          "INT": v.international,
          "OTS": v.ots,
          "ECOM": v.ecommerce,
          "NORD": v.nord,
          "L&T D2C": v.lt_d2c,
          // "VERISHOP": v.verishop_canada,
          // "BGS": v.bgs,
          "POD": v.pod,
        };
      })
    )
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };


  const getSortedData = (data, sortedInfo) => {
    if (!sortedInfo.order) return data;

    const { columnKey, order } = sortedInfo;
    return [...data].sort((a, b) => {
      const aValRaw = a[columnKey];
      const bValRaw = b[columnKey];

      const aVal = Number(
        typeof aValRaw === "string"
          ? aValRaw.replace(/,/g, "")
          : aValRaw
      );
      const bVal = Number(
        typeof bValRaw === "string"
          ? bValRaw.replace(/,/g, "")
          : bValRaw
      );

      if (isNaN(aVal)) return 1;
      if (isNaN(bVal)) return -1;

      if (order === "ascend") {
        return aVal - bVal;
      } else {
        return bVal - aVal;
      }
    });
  };

  const handleDownloadPDF = () => {
    const columns = [
      "#", "Gender", "Current Season", "SKU", "Inseam", "Style", "Wash", "Fit Category", "WS", "RTL", "BERGEN", "TRNS", "PK", "PROD", "PEND",
      "INT", "OTS", "ECOM", "NORD", "L&T d2C", "POD"
    ];

    const rows = [];
    const sortedData = getSortedData(data, sortedInfo);
    sortedData.forEach((item, index) => {
      const row = [
        index + 1,
        item.gender,
        item.current_season,
        item.item_code,
        item.inseam,
        item.style,
        item.wash,
        item.fit_category,
        numeral(item.ws_price).format('$0,0'),
        numeral(item.retail_price).format('$0,0'),
        numeral(item.bergan).format('0,0'),
        numeral(item.transit).format('0,0'),
        numeral(item.pakistan).format('0,0'),
        numeral(item.production).format('0,0'),
        numeral(item.pending).format('0,0'),
        numeral(item.international).format('0,0'),
        numeral(item.ots).format('0,0'),
        numeral(item.ecommerce).format('0,0'),
        numeral(item.nord).format('0,0'),
        numeral(item.lt_d2c).format('0,0'),
        numeral(item.pod).format('0,0')
      ];
      rows.push(row);
    });

    generateDynamicPDF({
      filename: 'Stock-Style-SKU-Report-Summary.pdf',
      headers: [
        genderName && { label: 'Gender', value: genderName },
        fitName && { label: 'Fit Category', value: fitName },
        seasonName && { label: 'Season', value: seasonName },
        yearName && { label: 'Season Year', value: yearName },
        CatergoryName && { label: 'Category', value: CatergoryName },
        sku && { label: 'Sku', value: sku },
        styleName && { label: 'Style', value: styleName },
        washName && { label: 'Wash', value: washName },
        isChecked2.length > 0 && filterProductStatusName?.length > 0 && {
          label: 'Product Status',
          value: filterProductStatusName.map(val => val.product_status_name).join(', '),
        },
        {
          label: 'Pending Till',
          value: moment(form.getFieldValue('as_on_date')).format('MM-DD-YYYY'),
        },
      ].filter(Boolean), // removes any false/null values
      columns,
      rows,
      rowsRaw: sortedData,
      totalFields: ["bergan", "transit", "pakistan",
        "production", "pending", "international", "ots", "ecommerce", "nord", "lt_d2c", "pod"],
      totalFieldIndexes: {
        bergan: 10,
        transit: 11,
        pakistan: 12,
        production: 13,
        pending: 14,
        international: 15,
        ots: 16,
        ecommerce: 17,
        nord: 18,
        lt_d2c: 19,
        pod: 20,
        // pod_amount: 24
      },
      totalLabelIndex: 9,
      rightAlignIndexes: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      margin: { top: 10, left: 5, right: 5, bottom: 2 }
    });
  };

  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getProductType(token, values));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getProductClass(token, menuId));
    dispatch(getSize(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getFitCategory(token, menuId));
    dispatch(getFitCategoryNew(token, menuId));
    dispatch(getWashName(token, menuId));
    dispatch(getSeasonYear(token, menuId));


  }, [dispatch, menuId, token]);

  useEffect(() => {
    if (allSesion) {
      setIsChecked([]);
    }
  }, [allSesion])

  // useEffect(() => {
  //   if (allStatus) {
  //     setIsChecked2([]);
  //   }
  // }, [allStatus])

  useEffect(() => {
    if (isChecked2.length === 0) {
      setAllStatus(true);
    }
  }, [isChecked2]);

  useEffect(() => {
    if (allPC) {
      setIsPCChecked([]);
    }
  }, [allPC])



  const handlePrint = () => {
    const css = '@page { margin-top: 30px; margin-bottom: 30px }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  const handleExcelExport = () => {
    const excel = new Excel();
    excel
      .addSheet("test")
      .addColumns(columsPageOne)
      .addDataSource(omsStockSummary?.payload?.data, {
        str2Percent: true,
      })
      .setTHeadStyle()
      .saveAs("Excel.xlsx");
  };

  const columsPageOne = [
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Gender Cateogry",
      dataIndex: "gender_cateogry",
      key: "gender_cateogry",
    },
    {
      title: "Current Season",
      dataIndex: "current_season",
      key: "current_season",
    },
    {
      title: "Fabric",
      dataIndex: "fabric",
      key: "fabric",
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
    },
    {
      title: "SKU",
      dataIndex: "item_code",
      key: "item_code",
    },
    {
      title: "Style",
      dataIndex: "style",
      key: "style",
    },
    {
      title: "Wash",
      dataIndex: "wash",
      key: "wash",
    },
    {
      title: "Fit Category",
      dataIndex: "fit_category",
      key: "fit_category",
    },
    {
      title: "Production",
      dataIndex: "production",
      key: "producti  on",
    },
    {
      title: "PK",
      dataIndex: "pakistan",
      key: "pakistan",
    },
    {
      title: "Transit",
      dataIndex: "transit",
      key: "transit",
    },
    {
      title: "Bergen",
      dataIndex: "bergan",
      key: "bergan",
    },
    {
      title: "Pending",
      dataIndex: "pending",
      key: "pending",
    },
    {
      title: "Intl",
      dataIndex: "international",
      key: "international",
    },
    {
      title: "OTS",
      dataIndex: "ots",
      key: "ots",
    },
    {
      title: "Retail",
      dataIndex: "retail_price",
      key: "retail_price",
    },
    {
      title: "Cost Price",
      dataIndex: "ws_price",
      key: "ws_price",
    },
  ];


  const columns = [
    {
      title: "S#",
      align: "center",
      width: "60px",
      render: (text, record, index) => {
        return index + 1
      }
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.gender !== null) {
          return record.gender
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.gender !== null) & (b.gender !== null)) {
          return a.gender.localeCompare(b.gender);
        }
      },
    },
    {
      title: "Current Season",
      dataIndex: "current_season",
      key: "current_season",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.current_season !== null) {
          return record.current_season
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.current_season !== null) & (b.current_season !== null)) {
          return a.current_season.localeCompare(b.current_season);
        }
      },
    },
    {
      title: "SKU",
      dataIndex: "item_code",
      key: "item_code",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.item_code !== null) {
          return record.item_code
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.item_code !== null) & (b.item_code !== null)) {
          return a.item_code - b.item_code;;
        }
      },
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.inseam !== null) {
          return record.inseam
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.inseam !== null) & (b.inseam !== null)) {
          return a.inseam - b.inseam;
        }
      },
    },
    {
      title: "Style",
      dataIndex: "style",
      key: "style",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.style !== null) {
          return record.style
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.style !== null) & (b.style !== null)) {
          return a.style.localeCompare(b.style);
        }
      },
    },
    {
      title: "Wash",
      dataIndex: "wash",
      key: "wash",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.wash !== null) {
          return record.wash
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.wash !== null) & (b.wash !== null)) {
          return a.wash.localeCompare(b.wash);
        }
      },
    },


    // {
    //   title: "Fit Category",
    //   dataIndex: "fit_category",
    //   key: "fit_category",
    //   filterDropdown: ({
    //     setSelectedKeys,
    //     selectedKeys,
    //     confirm,
    //     clearFilters,
    //   }) => {
    //     return (
    //       <>
    //         <Input
    //           allowClear
    //           autoFocus
    //           className="pop-search-gen pop-220 w-100"
    //           value={selectedKeys[0]}
    //           onChange={(e) => {
    //             setSelectedKeys(e.target.value ? [e.target.value] : []);
    //             confirm({ closeDropdown: false });
    //           }}
    //           onPressEnter={() => {
    //             confirm();
    //           }}
    //           onBlur={() => {
    //             confirm();
    //           }}
    //         />
    //       </>
    //     );
    //   },
    //   filterIcon: (filtered) =>
    //     filtered ? <FilterFilled /> : <SearchOutlined />,
    //   onFilter: (value, record) => {
    //     if (record.fit_category !== null) {
    //       return record.fit_category
    //         .toString()
    //         .toLowerCase()
    //         .includes(value.toLowerCase());
    //     }
    //   },
    //   sorter: (a, b) => {
    //     if ((a.fit_category !== null) & (b.fit_category !== null)) {
    //       return a.fit_category.localeCompare(b.fit_category);
    //     }
    //   },
    // },
    // {
    //   title: "WS",
    //   dataIndex: "ws_price",
    //   key: "ws_price",
    //   render: (text, record) => {
    //     return <>$ {numeral(text).format("0,00.00")}</>
    //   },
    //   align: "right",
    //   filterDropdown: ({
    //     setSelectedKeys,
    //     selectedKeys,
    //     confirm,
    //     clearFilters,
    //   }) => {
    //     return (
    //       <>
    //         <Input
    //           allowClear
    //           autoFocus
    //           className="pop-search-gen pop-220 w-100"
    //           value={selectedKeys[0]}
    //           onChange={(e) => {
    //             setSelectedKeys(e.target.value ? [e.target.value] : []);
    //             confirm({ closeDropdown: false });
    //           }}
    //           onPressEnter={() => {
    //             confirm();
    //           }}
    //           onBlur={() => {
    //             confirm();
    //           }}
    //         />
    //       </>
    //     );
    //   },
    //   filterIcon: (filtered) =>
    //     filtered ? <FilterFilled /> : <SearchOutlined />,
    //   onFilter: (value, record) => {
    //     if (record.ws_price !== null) {
    //       return record.ws_price
    //         .toString()
    //         .toLowerCase()
    //         .includes(value.toLowerCase());
    //     }
    //   },
    //   sorter: (a, b) => {
    //     if ((a.ws_price !== null) & (b.ws_price !== null)) {
    //       return a.ws_price - b.ws_price;
    //     }
    //   },
    // },
    // {
    //   title: "RTL",
    //   dataIndex: "retail_price",
    //   key: "retail_price",
    //   render: (text, record) => {
    //     return <>$ {numeral(text).format("0,00.00")}</>
    //   },
    //   align: "right",
    //   filterDropdown: ({
    //     setSelectedKeys,
    //     selectedKeys,
    //     confirm,
    //     clearFilters,
    //   }) => {
    //     return (
    //       <>
    //         <Input
    //           allowClear
    //           autoFocus
    //           className="pop-search-gen pop-220 w-100"
    //           value={selectedKeys[0]}
    //           onChange={(e) => {
    //             setSelectedKeys(e.target.value ? [e.target.value] : []);
    //             confirm({ closeDropdown: false });
    //           }}
    //           onPressEnter={() => {
    //             confirm();
    //           }}
    //           onBlur={() => {
    //             confirm();
    //           }}
    //         />
    //       </>
    //     );
    //   },
    //   filterIcon: (filtered) =>
    //     filtered ? <FilterFilled /> : <SearchOutlined />,
    //   onFilter: (value, record) => {
    //     if (record.retail_price !== null) {
    //       return record.retail_price
    //         .toString()
    //         .toLowerCase()
    //         .includes(value.toLowerCase());
    //     }
    //   },
    //   sorter: (a, b) => {
    //     if ((a.retail_price !== null) & (b.retail_price !== null)) {
    //       return a.retail_price - b.retail_price;
    //     }
    //   },
    // },
    {
      title: "Fit Category",
      dataIndex: "fit_category",
      key: "fit_category",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.fit_category !== null) {
          return record.fit_category
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.fit_category !== null) & (b.fit_category !== null)) {
          return a.fit_category.localeCompare(b.fit_category);
        }
      },
    },
    {
      title: "WS",
      dataIndex: "ws_price",
      key: "ws_price",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>;
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.ws_price !== null) {
          return record.ws_price
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.ws_price !== null) & (b.ws_price !== null)) {
          return a.ws_price - b.ws_price;
        }
      },
    },
    {
      title: "RTL",
      dataIndex: "retail_price",
      key: "retail_price",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>;
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.retail_price !== null) {
          return record.retail_price
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.retail_price !== null) & (b.retail_price !== null)) {
          return a.retail_price - b.retail_price;
        }
      },
    },
    {
      title: "BERGEN",
      dataIndex: "bergan",
      key: "bergan",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.bergan !== null) {
          return record.bergan
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.bergan !== null) & (b.bergan !== null)) {
          return a.bergan - b.bergan;
        }
      },
    },
    {
      title: "TRNS",
      dataIndex: "transit",
      key: "transit",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.transit !== null) {
          return record.transit
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.transit !== null) & (b.transit !== null)) {
          return a.transit - b.transit;
        }
      },
    },
    {
      title: "PK",
      dataIndex: "pakistan",
      key: "pakistan",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.pakistan !== null) {
          return record.pakistan
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.pakistan !== null) & (b.pakistan !== null)) {
          return a.pakistan - b.pakistan;
        }
      },
    },
    {
      title: "PROD",
      dataIndex: "production",
      key: "production",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.production !== null) {
          return record.production
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.production !== null) & (b.production !== null)) {
          return a.production - b.production;
        }
      },
    },
    {
      title: "PEND",
      dataIndex: "pending",
      key: "pending",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.pending !== null) {
          return record.pending
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.pending !== null) & (b.pending !== null)) {
          return a.pending - b.pending;
        }
      },
    },
    {
      title: "INT",
      dataIndex: "international",
      key: "international",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.international !== null) {
          return record.international
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.international !== null) & (b.international !== null)) {
          return a.international - b.international;
        }
      },
    },
    {
      title: <span className="txtbold">OTS</span>,
      dataIndex: "ots",
      key: "ots",
      render: (text, record) => {
        return <span className="txtbold">{numeral(text).format('0,0')}</span>
      },

      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.ots !== null) {
          return record.ots
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.ots !== null) & (b.ots !== null)) {
          return a.ots - b.ots;
        }
      },
    },
    {
      title: "ECOM",
      dataIndex: "ecommerce",
      key: "ecommerce",

      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.ecommerce !== null) {
          return record.ecommerce
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.ecommerce !== null) & (b.ecommerce !== null)) {
          return a.ecommerce - b.ecommerce;
        }
      },
    },
    {
      title: "NORD",
      dataIndex: "nord",
      key: "nord",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.nord !== null) {
          return record.nord
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.nord !== null) & (b.nord !== null)) {
          return a.nord - b.nord;
        }
      },
    },
    {
      title: "L&T D2C",
      dataIndex: "lt_d2c",
      key: "lt_d2c",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.lt_d2c !== null) {
          return record.lt_d2c
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.lt_d2c !== null) & (b.lt_d2c !== null)) {
          return a.lt_d2c - b.lt_d2c;
        }
      },
    },
    {
      title: "POD",
      dataIndex: "pod",
      key: "pod",
      render: (text, record) => {
        return <>{numeral(text).format('0,0')}</>
      },
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.pod !== null) {
          return record.pod
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.pod !== null) & (b.pod !== null)) {
          return a.pod - b.pod;
        }
      },
    },
  ];

  const bergenTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.bergan), 0)
  const trnsTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.transit), 0)
  const pkTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.pakistan), 0)
  const prodTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.production), 0)
  const pendTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.pending), 0)
  const intTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.international), 0)
  const otsTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.ots), 0)
  const ecomTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.ecommerce), 0)
  const nordTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.nord), 0)
  const ltD2c = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.lt_d2c), 0)
  const podTotal = omsStockSummary?.payload?.data.reduce((acc, item, index) => acc + parseFloat(item.pod), 0)


  const handleGender = (gender_id) => {
    dispatch(getGenderCategoryChange(token, gender_id));
    dispatch(getStyleChange(token, gender_id, null, null));
    form.setFieldsValue({
      gender_category_id: "All",
      style_id: "All",
      sku: "All"
    })
  }


  const handleStyle = (gender_category_id) => {
    dispatch(getStyleChange(token, form.getFieldValue().gender_id, gender_category_id, null))
    form.setFieldsValue({
      style_id: "All",
      sku: "All"
    })
  }

  const handleSku = (sku_id) => {
    if (sku_id === null) {
      dispatch(getSku(token, null, null, null));
    } else {
      dispatch(getSku(token, form.getFieldValue().gender_id, form.getFieldValue().gender_category_id, sku_id));
    }
    form.setFieldsValue({
      sku: "All"
    })
  }


  function debounce(cb, delay = 1000) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        cb(...args)
      }, delay)
    }
  }


  const handleSkuSearch = () => {
    dispatch(getSku(token, null, null, null));
  }

  const optimizedFn = useCallback(debounce(handleSkuSearch), []);

  const filterProductStatusName = productStatus?.payload?.data?.filter(item => isChecked2.includes(item.product_status_id));


  return (
    <div className="header_class business_header_oms" id="card-pdf" >
      <div
        style={{
          width: "100%",
          height: "100vh",
          position: "absolute",
          top: 0,
          left: -10000,
          // left: 0,
          zIndex: 1001,
        }}
      >
        <div className="header_class business_header_oms" id="carddd">
          <div className="row justify-content-between business_class_oms distributor" style={{ width: "100%" }}>
            <div className="col-3 d-flex align-items-start box-space">
              <div className="logobrand">
                <img id="ImgLogo" alt="logo" src={logo} />
              </div>
            </div>
            <div className="col-4 box-space right-content-header text-right">
              <div className=" d-flex justify-content-end">
                <span style={{ fontSize: "small", fontWeight: "bolder" }}>
                  Stock Report Summary
                  <br />
                  Rpt # 489
                  <br />
                  <p className=" mb-0">Rpt # 001_V4</p>
                  Login as:{" "}
                  <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                    {userName}
                  </span>
                  <br />
                </span>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 20 }}>
            {genderName && <div>Gender: {genderName}</div>}
            {fitName && <div>Fit Category: {fitName}</div>}
            {seasonName && <div>Season: {seasonName}</div>}
            {yearName && <div>Season Year: {yearName}</div>}
            {CatergoryName && <div>Category: {CatergoryName}</div>}
            {sku && <div>Sku: {sku}</div>}
            {styleName && <div>Style: {styleName}</div>}
            {washName && <div>Wash: {washName}</div>}
            {
              isChecked2.length > 0 && <div>
                Product Status : {filterProductStatusName && filterProductStatusName.map((val, key) => {
                  return <span key={key}>{val.product_status_name} </span>
                })}
              </div>
            }
            <div>Pending Till: {moment(form.getFieldValue().as_on_date).format("MM-DD-YYYY")}</div>
          </div>
          <Table
            className="  border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style border"
            ref={tableRef}
            size="small"
            bordered={false}
            type="company"
            headerClassName='abc'
            dataSource={data && data}
            columns={columns}
            scroll={{ x: 'max-content' }}
            loading={omsStockSummary?.loading}
            pagination={{
              defaultCurrent: 1,
              defaultPageSize: 500,
              pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
            }}
            // sticky={true}
            summary={(pageData) => {
              return (
                <>
                  <Table.Summary.Row>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell><p style={{ textAlign: "center", margin: "0" }}>
                      Total &gt; &gt; &gt;
                    </p></Table.Summary.Cell>
                    {/* <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell> */}
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {bergenTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {trnsTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {pkTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {prodTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {pendTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {intTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {otsTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {ecomTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {nordTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {ltD2c?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                        {podTotal?.toLocaleString("en-US")}
                      </p>
                    </Table.Summary.Cell>

                  </Table.Summary.Row>
                </>
              );
            }}
          />
        </div>
      </div>
      <div className="header_class business_header_oms">
        <div className="row justify-content-between business_class_oms distributor">
          <div className="col-3 d-flex align-items-start box-space">
            <div className="logobrand">
              <img id="ImgLogo" alt="logo" src={logo} />
            </div>
          </div>
          {/* <div className="col-sm-6 box-space pl-sm-0">
                    <div className="brand-para">
                        <div>DL1961 Premium Denim Inc.</div>
                        <div>121 Varick Street</div>
                        <div>4th Floor</div>
                        <div>New York, NY 10013</div>
                        <div>(P) 646-514-9736</div>
                        <div>(F) 212-991-9989</div>
                        <div>(E) sales@DL1961.com</div>
                    </div>
                </div> */}
          <div className="col-4 box-space right-content-header text-right">
            <div className=" d-flex justify-content-end">
              <div className=" d-flex justify-content-end mr-8 printing_class">
                <div className="print_icon printing_class">
                  <i
                    onClick={handlePrint}
                    id="Image1"
                    title="Print"
                    alt="Print"
                    src={btnPrint}
                    className="fa-solid fa-print"
                  ></i>
                </div>
                <div className="print_icon printing_class">
                  <CSVLink
                    filename={"Oms-Stock-Summary.csv"}
                    data={excelData}
                    style={{ display: "flex" }}
                    onClick={() => {

                    }}
                  >
                    <input
                      type="image"
                      name="ImgExcel"
                      alt="Export to excel"
                      id="ImgExcel"
                      title="Export to excel"
                      src={xlsx}
                      style={{ borderWidth: "0px", height: "14px" }}
                    // onClick={handleExcelExport}
                    />
                  </CSVLink>
                </div>
                <div className="print_icon printing_class" >
                  <input
                    type="image"
                    name="ImgPDF"
                    alt="Export to PDF"
                    id="ImgPDF"
                    title="Export to PDF"
                    src={pdf}
                    onClick={handleDownloadPDF}
                    style={{ borderWidth: "0px", height: "18px" }}
                  />
                </div>
              </div>
              <span style={{ fontSize: "small", fontWeight: "bolder" }}>
                Stock Report SKU Wise Summary
                <br />
                Rpt # 489
                <br />
                <p className=" mb-0">Rpt # 001_V4</p>
                Login as:{" "}
                <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                  {userName}
                </span>
                <br />
              </span>
            </div>
            {/* Last Updated By:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {moment(routineLog[0]?.r_date +"T"+ routineLog[0]?.r_time).format('MM-DD-YYYY, hh:mm a')}
              </span> */}
          </div>
        </div>


        <div className="business_class_oms mb-2 distributor">
          <Form form={form} name="control-hooks" onFinish={onFinish}>
            <div className="main_form row">
              <div className="col-12">
                <hr className="my-1" />
                <div>
                  <label htmlFor="">Product Status</label>
                  <div className="checkboxes">
                    <div className="checkbox_content">
                      <Form.Item name="current_status_id" className=" mb-0">
                        <Checkbox checked={allStatus} onChange={statusSelectAll}>
                          All
                        </Checkbox>
                      </Form.Item>
                    </div>
                    {productStatus &&
                      productStatus?.payload?.data.map((it, index) => {
                        return (
                          <div key={index} className="checkbox_content">
                            <Form.Item name="current_status_id">
                              <Checkbox
                                checked={allStatus ? false : isChecked2.includes(it.product_status_id)}
                                onChange={(e) =>
                                  isCheckboxChecked2(
                                    it.product_status_id,
                                    e.target.checked
                                  )
                                }
                              >
                                {it.product_status_name}
                              </Checkbox>
                            </Form.Item>
                          </div>
                        );
                      })}
                  </div>
                </div>
                <hr className="my-1" />
                <div className="main_form row">
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">Gender</label>
                      <div className="w-100">
                        <Form.Item name="gender_id" initialValue={"All"}>
                          <Select
                            className={"select_Inputs"}
                            showSearch
                            // placeholder="Select Gender"
                            optionFilterProp="children"
                            size="small"
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null ?
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                            }
                            onChange={(e, obj) => setGenderName(obj.children)}
                          >
                            <Option value={null}>All</Option>
                            {gender &&
                              gender?.payload?.data.map((it, index) => {
                                return (
                                  <Option key={index} value={it.gender_id}>
                                    {it.gender_name}
                                  </Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">Season</label>
                      <div className=" w-100">
                        <Form.Item name="season_id" initialValue={'All'}>
                          <Select
                            defaultValue={form.getFieldValue().season_id}
                            className={"select_Inputs"}
                            showSearch
                            // placeholder="Select Product Status"
                            optionFilterProp="children"
                            size="small"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null ?
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                            }
                            onChange={(e, obj) => setSeasonName(obj.children)}
                          >
                            <Option value={null}>All</Option>
                            {season &&
                              season?.payload?.data?.map(
                                (status, index) => {
                                  return (
                                    <Option
                                      key={index}
                                      value={status.season_id}
                                    >
                                      {status.season_name}
                                    </Option>
                                  );
                                }
                              )}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">Season Year</label>
                      <div className="w-100">
                        <Form.Item name="new_season_year_id" initialValue={"All"}>
                          <Select
                            className={"select_Inputs"}
                            defaultValue={form.getFieldValue().new_season_year_id}
                            showSearch
                            optionFilterProp="children"
                            size="small"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== "All" ?
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                            }
                            onChange={(e, obj) => setYearName(obj.children)}
                          >
                            <Option value={"All"}>All</Option>
                            {seasonYear?.payload?.data?.map((res) => <Option key={res.season_year_id} value={res.season_year_id}>{res.season_year}</Option>
                            )}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/*Second*/}
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">Category</label>
                      <div className="w-100">
                        <Form.Item initialValue={"All"} name="gender_category_id">
                          <Select
                            className={"select_Inputs"}
                            showSearch
                            // placeholder="Product Category"
                            optionFilterProp="children"
                            size="small"
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null ?
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                            }
                            // filterOption={(input, option) =>
                            //   option.children
                            //     .toLowerCase()
                            //     .includes(input.toLowerCase())
                            // }
                            onChange={(e, obj) => setYearName(obj.children)}
                          >
                            <Option value={null}>All</Option>
                            {
                              genderCategoryChange &&
                                genderCategoryChange?.payload?.data.length >= 0 ? (
                                genderCategoryChange &&
                                genderCategoryChange?.payload?.data.map((it, index) => {
                                  return (
                                    <Option
                                      key={index}
                                      value={it.gender_category_id}
                                    >
                                      {it.gender_category_name}
                                    </Option>
                                  );
                                })
                              ) : (
                                genderCategory &&
                                genderCategory?.payload?.data.map((it, index) => {
                                  return (
                                    <Option
                                      key={index}
                                      value={it.gender_category_id}
                                    >
                                      {it.gender_category_name}
                                    </Option>
                                  );
                                })
                              )
                            }
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="main_form row form-margin">
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">Sku</label>
                      <div className="w-100">
                        <Form.Item name="sku" initialValue={"All"}>
                          <Select
                            notFoundContent={Sku.loading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              <Loader type="Oval" color="#3c4b58" height={20} width={20} />
                            </div> : <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>No Data</div>}
                            className={"select_Inputs"}
                            showSearch
                            onSearch={(value) => {
                              optimizedFn(value)
                            }}
                            // placeholder="Select Gender"
                            optionFilterProp="children"
                            size="small"
                            onChange={(e, obj) => setSKU(obj.children)}
                          >
                            <Option value={null}>All</Option>
                            {Sku &&
                              Sku?.payload?.data.map((it, index) => {
                                return (
                                  // <Option value="ABC">ABC</Option>
                                  <Option key={index} value={it.sku}>
                                    {it.sku}
                                  </Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">Style</label>
                      <div className="w-100">
                        <Form.Item initialValue={"All"} name="style_id">
                          <Select
                            className={"select_Inputs"}
                            showSearch
                            // placeholder="Select a person"
                            optionFilterProp="children"
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null ?
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                            }
                            size="small"
                            onChange={(e, obj) => setStyleName(obj.children)}
                          // filterOption={(input, option) =>
                          //   option.children
                          //     .toLowerCase()
                          //     .includes(input.toLowerCase())
                          // }
                          >
                            <Option value={null}>All</Option>
                            {
                              styleChange && styleChange?.payload?.data.length >= 0 ? (
                                styleChange && styleChange?.payload?.data.map((style, index) => {
                                  return (
                                    <Option key={index} value={style.style_id}>
                                      {style.style_name}
                                    </Option>
                                  );
                                })
                              ) : (
                                style && style?.payload?.data.map((style, index) => {
                                  return (
                                    <Option key={index} value={style.style_id}>
                                      {style.style_name}
                                    </Option>
                                  );
                                })
                              )
                            }
                            {/* {style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_id}>
                                  {style.style_name}
                                </Option>
                              );
                            })} */}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">Wash</label>
                      <div className="w-100">
                        <Form.Item name="wash_id" initialValue={"All"}>
                          <Select
                            defaultValue={form.getFieldValue().wash_id}
                            className={"select_Inputs"}
                            showSearch
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null ?
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                            }
                            // placeholder="Select Product Status"
                            optionFilterProp="children"
                            size="small"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(e, obj) => setWashName(obj.children)}
                          >
                            <Option value={null}>All</Option>
                            {wash &&
                              wash?.payload?.data?.map(
                                (status, index) => {
                                  return (
                                    <Option
                                      key={index}
                                      value={status.wash_id}
                                    >
                                      {status.wash_name}
                                    </Option>
                                  );
                                }
                              )}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">
                        Fit Category
                      </label>
                      <div className="w-100">
                        <Form.Item initialValue={"All"} name="cut_id">
                          <Select
                            className={"select_Inputs"}
                            showSearch
                            // placeholder="Select a person"
                            optionFilterProp="children"
                            size="small"
                            onChange={(e, obj) => setFitName(obj.children)}
                          >
                            <Option value={null}>All</Option>
                            {fitCategoryNew &&
                              fitCategoryNew?.payload?.data
                                ?.slice()
                                ?.sort((a, b) =>
                                  a.cut_name.localeCompare(b.cut_name)
                                )
                                .map((item) => {
                                  return (
                                    <Option
                                      defaultValue="All"
                                      key={item.cut_id}
                                      value={item.cut_id}
                                    >
                                      {item.cut_name}
                                    </Option>
                                  );
                                })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="main_form row form-margin">
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">
                        Product Cat.
                      </label>
                      <div className="w-100">
                        <Form.Item initialValue={"All"} name="fit_category_id">
                          <Select
                            className={"select_Inputs"}
                            showSearch
                            // placeholder="Select a person"
                            optionFilterProp="children"
                            size="small"
                          // onChange={(e, obj) => setProductName(obj.children)}
                          >
                            <Option value={null}>All</Option>
                            {fitCategory &&
                              fitCategory?.payload?.data
                                ?.sort((a, b) =>
                                  a.fit_category_name.localeCompare(
                                    b.fit_category_name
                                  )
                                )
                                .map((item) => {
                                  return (
                                    <Option
                                      defaultValue="All"
                                      key={item.fit_category_id}
                                      value={item.fit_category_id}
                                    >
                                      {item.fit_category_name}
                                    </Option>
                                  );
                                })}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">
                        Pending Till
                      </label>
                      <div className="w-100">
                        <Form.Item
                          name="as_on_date"
                          className="full_date"
                          initialValue={toDateNew()}
                        >
                          <DatePicker size="small" format={dateFormatList} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <label className="labels width44" htmlFor="">
                        Sort on
                      </label>
                      <div className="w-100">
                        <Form.Item
                          name="sorting"
                          initialValue={"ots"}   // <-- DEFAULT VALUE SET HERE
                        >
                          <Select
                            size="small"
                            // style={{ width: '100%' }}
                            className={"select_Inputs"}

                          >
                            <Option value="gender">Gender</Option>
                            <Option value="current_season">Current Season</Option>
                            <Option value="sku">Sku</Option>
                            <Option value="style">Style</Option>
                            <Option value="wash">Wash</Option>
                            <Option value="fit_category">Fit Category</Option>
                            {/* Default target option */}
                            <Option value="ots">OTS</Option>
                            {/* <Select value="ws">WS</Select>
                          <Select value="rtl">RTL</Select>
                          <Select value="bergen">Bergen</Select>
                          <Select value="trns">TRNS</Select>
                          <Select value="pk">PK</Select>
                          <Select value="prod">PROD</Select>
                          <Select value="pend">PEND</Select>
                          <Select value="int">INT</Select>
                          <Select value="ecom">ECOM</Select>
                          <Select value="nord">NORD</Select>
                          <Select value="saks">SAKS</Select>
                          <Select value="moda">Moda</Select>
                          <Select value="macys">MACYS</Select>
                          <Select value="anthro">Anthro</Select>
                          <Select value="pod">POD</Select> */}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "3px",
                          float: "right",
                        }}
                      >
                        <Button
                          style={{ width: "fit-content" }}
                          type="primary"
                          htmlType="submit"
                          className="submit-btn-btm m-0"
                        >
                          Generate
                        </Button>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </Form>
        </div>
        <div>
          <div
          // className="overflow"
          //   style={{
          //     overflowY: "scroll",
          //     height: "57vh",
          //     // borderBottom: "1px solid black"
          //   }}
          >
            {omsStockSummary?.payload?.data !== undefined ?
              (
                data.length > 0 ? (
                  <div id="card">
                    <div style={{ display: "flex", gap: 20 }}>
                      {genderName && <div>Gender: {genderName}</div>}
                      {seasonName && <div>Season: {seasonName}</div>}
                      {yearName && <div>Season Year: {yearName}</div>}
                      {CatergoryName && <div>Category: {CatergoryName}</div>}
                      {sku && <div>Sku: {sku}</div>}
                      {styleName && <div>Style: {styleName}</div>}
                      {washName && <div>Wash: {washName}</div>}
                      {
                        isChecked2.length > 0 && <div>
                          Product Status : {filterProductStatusName && filterProductStatusName.map((val, key) => {
                            return <span key={key}>{val.product_status_name} </span>
                          })}
                        </div>
                      }

                      <div>Pending Till: {moment(form.getFieldValue().as_on_date).format("MM-DD-YYYY")}</div>
                    </div>
                    <Table
                      className="fix-scroll-table table-header-sticky border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style border omsTable"
                      ref={tableRef}
                      size="small"
                      bordered={false}
                      type="company"
                      headerClassName='abc'
                      dataSource={data && data}
                      columns={columns}
                      scroll={{ x: 'max-content' }}
                      loading={omsStockSummary.loading}
                      onChange={handleTableChange}
                      pagination={{
                        defaultCurrent: 1,
                        defaultPageSize: 500,
                        pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                      }}
                      // sticky={true}
                      summary={(pageData) => {
                        return (
                          <>
                            <Table.Summary.Row>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell><p style={{ textAlign: "center", margin: "0" }}>
                                Total &gt; &gt; &gt;
                              </p></Table.Summary.Cell>
                              {/* <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell> */}
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {bergenTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {trnsTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {pkTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {prodTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {pendTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {intTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {otsTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {ecomTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {nordTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {ltD2c.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  {podTotal.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>

                            </Table.Summary.Row>
                          </>
                        );
                      }}
                    />
                  </div>
                ) : (
                  <div className="no-Data">
                    {/* {console.log(omsStockSummary?.payload?.data.length, 'omsStockSummary?.payload?.data.length')} */}
                    <h1>No Data</h1>
                  </div>

                )
              ) : (
                loading && (
                  <div className="loader" style={{ marginTop: "20px" }}>
                    <Spin size="medium" />
                  </div>
                )
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default OmsStockSummary;
